/**
 * Un refus de quota se lit-il dans cette réponse ?
 *
 * Le serveur rend `denyCode = 'QUOTA_ATTEINT'` avec le compte et le plafond.
 * Ce n'est PAS une erreur : c'est un état normal du modèle, et le principal
 * point d'entrée de la vente. Le traiter comme une erreur afficherait une
 * ligne rouge là où il faut un écran qui explique et propose.
 *
 * ColdFusion rend ses clés en casses variables : les trois sont lues.
 *
 * @param {object} reponse - Ce que rend createBook, InsertMoment, etc.
 * @returns {{current: number, max: number, periodUnit: string, periodCount: number}|null}
 *   null si ce n'est pas un quota. periodUnit vaut '' pour un plafond total, ou
 *   'day' | 'week' | 'month' | 'year' pour une limite sur une durée glissante.
 */
export function lireRefusQuota(reponse) {
    if (!reponse) return null;

    const success = reponse.success ?? reponse.SUCCESS;
    if (success) return null;

    const code = reponse.denyCode ?? reponse.DENYCODE ?? reponse.denycode ?? '';
    if (String(code).toUpperCase() !== 'QUOTA_ATTEINT') return null;

    const current = Number(reponse.current ?? reponse.CURRENT ?? 0);
    const max = Number(reponse.max ?? reponse.MAX ?? 0);

    const periodUnit = String(reponse.periodUnit ?? reponse.PERIODUNIT ?? reponse.periodunit ?? '').toLowerCase();
    const periodCount = Number(reponse.periodCount ?? reponse.PERIODCOUNT ?? reponse.periodcount ?? 1);

    return {
        current: Number.isFinite(current) ? current : 0,
        max: Number.isFinite(max) ? max : 0,
        periodUnit,
        periodCount: Number.isFinite(periodCount) && periodCount >= 1 ? periodCount : 1
    };
}

/**
 * Un refus de FONCTION se lit-il dans cette réponse ?
 *
 * Le serveur rend `denyCode = 'FONCTION_NON_INCLUSE'` quand la fonction demandée est réservée
 * aux abonnements payants (par exemple recommander un membre). Comme un quota atteint, ce n'est
 * pas une erreur : il faut un écran qui explique et propose l'abonnement.
 *
 * @returns {boolean}
 */
export function lireRefusFonction(reponse) {
    if (!reponse) return false;
    const success = reponse.success ?? reponse.SUCCESS;
    if (success) return false;
    const code = reponse.denyCode ?? reponse.DENYCODE ?? reponse.denycode ?? '';
    return String(code).toUpperCase() === 'FONCTION_NON_INCLUSE';
}
